// https://vuex.vuejs.org/en/getters.html

export default {
  shippings(state) {
    return state.shippings;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
